import { CREATE_BLOCKED_USER } from '@client/collections/BlockedUser/schemas/createBlockedUser'
import { CommentFilterType } from '@client/collections/Comment/inteface'
import { COMMENTS } from '@client/collections/Comment/schemas/comments'
import { CREATE_COMMENT } from '@client/collections/Comment/schemas/createComment'
import { REMOVE_COMMENT } from '@client/collections/Comment/schemas/removeComment'
import { TOGGLE_COMMENT_LIKE } from '@client/collections/Comment/schemas/toggleCommentLike'
import { UPDATE_COMMENT } from '@client/collections/Comment/schemas/updateComment'
import { gqlApiInstance } from '@client/init'
import { BlockedTypeEnum } from '@interfaces/BlockedTypeEnum'
import { LikeSuccessStatusEnum } from '@models/book/LikeSuccessStatusEnum'
import { CommentsResponse } from '@models/comment/CommentsResponse'

export function useCommentAction() {
  async function comments(
    params: CommentFilterType
  ): Promise<CommentsResponse> {
    const res = await gqlApiInstance.request(COMMENTS, {
      ...params,
      sort: 'createdAt:desc',
    })
    return res.comments
  }

  async function createComment(params: {
    content: string
    parentCommentId?: number
    bookId: number
    bookChapterId?: number
    repliedId?: number
    wordCount: number
  }): Promise<any> {
    const { createCommnet } = await gqlApiInstance?.request(CREATE_COMMENT, {
      createCommentInput: params,
    })

    return createCommnet
  }

  async function updateComment(params: {
    id: number
    content?: string
    visible?: boolean
  }): Promise<any> {
    const res = await gqlApiInstance?.request(UPDATE_COMMENT, {
      updateCommentInput: params,
    })
    return res.updateComment
  }

  async function removeComment(id: number): Promise<any> {
    const res = await gqlApiInstance?.request(REMOVE_COMMENT, {
      removeCommentId: id,
    })

    return res.removeComment
  }

  async function blockComment(params: {
    id: number
    blockType: BlockedTypeEnum
  }): Promise<void> {
    await gqlApiInstance?.request(CREATE_BLOCKED_USER, {
      createBlockedUserInput: {
        blockedUserId: params.id,
        blockType: params.blockType,
      },
    })
  }

  async function toggleCommentLike(id: number): Promise<LikeSuccessStatusEnum> {
    const res = await gqlApiInstance?.request(TOGGLE_COMMENT_LIKE, {
      commentLikeInput: { commentId: id },
    })

    return res.toggleCommentLike.type
  }

  return {
    comments,
    createComment,
    updateComment,
    removeComment,
    blockComment,
    toggleCommentLike,
  }
}
